import alt from "../alt";

class FilmActions {
  constructor() {
    this.generateActions(
      "create",
      "delete",
      "updateFilms",
      "updateAllFilms",
      "fetchAllForUser",
      "fetchAllForEventBucket",
      "fetchAllForCreator",
      "fetchOne",
      "fetchFailed",
      "editFailed"
    );
  }

  editImage(id, field, file) {
    return { id, field, file };
  }

  edit(id, values) {
    return { id, values };
  }

  updateFilm(id, film) {
    return { id, film };
  }

  inviteContentCreator(id, email, options) {
    return { id, email, options };
  }
}

export default alt.createActions(FilmActions);



// WEBPACK FOOTER //
// ./src/app/actions/FilmActions.js